import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { DestroyRxComponent } from '../../../components/destroy-rx/destroy-rx.component';

@Component({
    selector: 'las-user-assignments-modal',
    templateUrl: './user-assignments-modal.component.html',
    styleUrls: ['./user-assignments-modal.component.scss'],
    standalone: false,
})
export class UserAssignmentsModalComponent
    extends DestroyRxComponent
    implements OnInit
{
    constructor(
        public dialogRef: MatDialogRef<UserAssignmentsModalComponent>,
        private router: Router,
    ) {
        super();
    }

    /**
     * Subscribes to NavigationEnd router event to close the modal when a bill link is clicked.
     * Will not run if the user clicks on the bill link for the current bill.
     */
    ngOnInit(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                takeUntil(this.destroy$),
            )
            .subscribe((_) => this.closePopup());
    }

    closePopup(): void {
        this.dialogRef.close();
    }
}
